/* A button invoking the project settings.
 * This button is meant to be part of group of navigation buttons.
 * When the settings are open, this button should highlight itself as "current" (aria-current + visual cue).
 */

import React, { memo } from 'react';
import { useNavigationProject } from '@atlassian/jira-business-entity-project/src/services/navigation-project/index.tsx';
import SharedProjectSettingsButton from '@atlassian/jira-navigation-kit-project-settings-button/src/ui/index.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

const JIRA_BUSINESS_BASE_PROJECT_URL = '/jira/core/projects';

const ProjectSettingsButton = () => {
	const { project } = useNavigationProject();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClick = () => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'horizontalNav', {
			itemId: 'settings',
		});
	};

	return (
		<SharedProjectSettingsButton
			project={project}
			projectUrlBase={JIRA_BUSINESS_BASE_PROJECT_URL}
			onClick={onClick}
		/>
	);
};

export default memo(ProjectSettingsButton);
